"use client";

import { SiteContainer } from "@/components/Container";
import { Box } from "@dxp-feed/ui/Box";
import { Button } from "@dxp-feed/ui/Button";
import { notFound } from "next/navigation";
import ImageWrapper from "../ImageWrapper";

const ErrorBoundry = ({ error }: { error: Error & { digest?: string } }) => {
  if (error.digest == "NEXT_NOT_FOUND") {
    notFound();
  }
  return (
    <SiteContainer className="h-screen flex items-center justify-center">
      <Box
        as="div"
        className="flex justify-center items-center flex-col pb-8 font-primaryFont text-center"
      >
        <ImageWrapper
          src={"/main-logo.svg"}
          alt={process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? ""}
          height={50}
          width={200}
        />
        <h1 className="font-bold text-6xl text-brandSecondary mt-5">
          Something went wrong!
        </h1>
        <p className="font-normal text-body py-2">
          An unexpected error occurred. Please try again later.
        </p>
        <Button
          variant="primary"
          className="mt-2 font-normal !text-body px-[24px]"
          onClick={() => {
            window.location.href = "/";
          }}
          aria-label="Try again"
        >
          Try Again
        </Button>
      </Box>
    </SiteContainer>
  );
};
export default ErrorBoundry;
